import PageLoader from "@jumbo/components/PageComponents/PageLoader";
import Loadable from "react-loadable";
import React from "react";

// const lazy=(loader) => Loadable({
//   loader: loader,
//   loading: PageLoader,
// });

const lazy = loader => React.lazy(loader);

export default lazy;
